// Lucide icon: x (https://lucide.dev/icons/x)
import { X } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconX = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <X />
    </IconComponentStyled>
  )
}
